import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';
import ConfigurableModal from '~organisms/ConfigurableModal';

export const Content = styled.div({
  display: 'flex',
  width: '100%',
});

export const Container = styled(ConfigurableModal)({
  '& .ant-modal-footer': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '10rem',
  },
});

export const SelectButton = styled(CommonButton)(({ theme }) => ({
  fontSize: theme.typography.size20,
  fontFamily: theme.typography.family.arial,
  letterSpacing: 0,
  color: theme.palette.darkLiver,
  opacity: 1,
}));
